module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload"
  }, [_c('ul', [_c('li', {
    staticClass: "rz-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("银行卡")]), _vm._v(" "), _c('div', {
    staticClass: "po"
  }, [(_vm.form.bank_card) ? _c('img', {
    ref: "img",
    attrs: {
      "alt": "",
      "width": 180,
      "height": 105
    }
  }) : _c('div', {
    staticClass: "ic"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/po.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击上传银行卡照片")])]), _vm._v(" "), _c('input', {
    ref: "fileinput",
    staticClass: "input-f",
    attrs: {
      "type": "file",
      "name": "",
      "id": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.selectBankC
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "rz-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("卡主姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "rz-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("上传身份证照片")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "po mb"
  }, [(_vm.form.ID_card_front) ? _c('img', {
    ref: "img2",
    attrs: {
      "alt": "",
      "width": 180,
      "height": 105
    }
  }) : _c('div', {
    staticClass: "ic"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/po.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("身份证正面")])]), _vm._v(" "), _c('input', {
    ref: "fileinput2",
    staticClass: "input-f",
    attrs: {
      "type": "file",
      "name": "",
      "id": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.selectIDCF
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "po"
  }, [(_vm.form.ID_card_back) ? _c('img', {
    ref: "img3",
    attrs: {
      "alt": "",
      "width": 180,
      "height": 105
    }
  }) : _c('div', {
    staticClass: "ic"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/po.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("身份证反面")])]), _vm._v(" "), _c('input', {
    ref: "fileinput3",
    staticClass: "input-f",
    attrs: {
      "type": "file",
      "name": "",
      "id": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.selectIDCB
    }
  })])])])]), _vm._v(" "), _c('button', {
    staticClass: "r-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f08da3ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/uploadImg/uploadImg.vue
// module id = 652
// module chunks = 31